import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import { CatIconInfoFilled } from '@blocks-react/components/Icons/InfoFilled';
import { Conditional } from '../../common';

type Props = {
  title: string;
  message: string;
  isPCCAssociatedDealerFFEnabledAndMobile?: boolean;
};

export const AssociatedDealerPriceWarning = ({
  title,
  message,
  isPCCAssociatedDealerFFEnabledAndMobile = false
}: Props) => {
  return (
    <CatInlineNotification
      heading={title}
      variant={!isPCCAssociatedDealerFFEnabledAndMobile ? 'error' : undefined}
    >
      <>
        <Conditional test={!isPCCAssociatedDealerFFEnabledAndMobile}>
          <CatIconWarningTriangle slot="before" />
        </Conditional>
        <Conditional test={isPCCAssociatedDealerFFEnabledAndMobile}>
          <CatIconInfoFilled slot="before" />
        </Conditional>
        {message}
      </>
    </CatInlineNotification>
  );
};
